import React from 'react';
import WebDesignedFloatingDock from '../WebDesignedFloatingDock';

const PadFloatingDock: React.FC = () => {
  return <WebDesignedFloatingDock forcedLayoutMode="pad" />;
};

export default PadFloatingDock;

